// True when the user's OS asks for reduced motion. For JS-driven animation (canvas, requestAnimationFrame);
// CSS should use the --motion-* tokens in core/styles.css or a prefers-reduced-motion media query instead.
export const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
